var map = {
	"./404.vue": [
		"8cdb",
		"chunk-2d0e95df"
	],
	"./Admin.vue": [
		"3530",
		"chunk-2d0b9d35"
	],
	"./Assessment.vue": [
		"d716",
		"chunk-4d392f5a",
		"chunk-7edbbd63"
	],
	"./Home.vue": [
		"bb51",
		"chunk-6e4f4bde"
	],
	"./Login.vue": [
		"a55b"
	],
	"./Profile.vue": [
		"c66d",
		"chunk-2d217357"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;